String.prototype.convertKebabToCamel = function() {
    let splited = this.split('-');
    let pascalString = splited.map(item => item.charAt(0).toUpperCase() + item.slice(1).toLowerCase()).join("");

    return pascalString.charAt(0).toLowerCase() + pascalString.slice(1);
}